export function useMaps() {
  function setLocation(place) {
    const streetNumber = getAddressComponent(place, "street_number");
    const streetName = getAddressComponent(place, "route");

    const location = {
      url: place.url,
      fullAddress: place.formatted_address,
      city: getAddressComponent(place, "locality"),
      postalCode: getAddressComponent(place, "postal_code"),
      coords: {
        lat: place.geometry.location.lat().toString(),
        lng: place.geometry.location.lng().toString()
      }
    };

    if (streetNumber) {
      location.streetNumber = streetNumber;
    }

    if (streetName) {
      location.streetName = streetName;
    }

    return location;
  }

  function getAddressComponent(place, type) {
    const component = place.address_components.find(
      comp => comp.types[0] === type
    );
    return component ? component.long_name : null;
  }

  return {
    setLocation
  };
}
